import { useState, useEffect, useCallback } from 'react';
import { transporterAPI } from '@/services/api';
import useAuthStore from '@/store/authStore';

export const useTransporterStats = () => {
  const { user } = useAuthStore();
  const [stats, setStats] = useState({
    missions_en_cours: 0,
    missions_terminees: 0,
    revenus_mois: 0,
    revenus_total: 0,
    note_moyenne: 0,
    vehicules_actifs: 0,
    nouvelles_demandes: 0,
    objectif_revenus: 0,
    pourcentage_objectif: 0,
    balance: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [shouldRefresh, setShouldRefresh] = useState(true);

  const fetchStats = useCallback(async () => {
    // Ne pas faire la requête si l'utilisateur n'est pas un transporteur
    if (!shouldRefresh || !user || user.role !== 'TRANSPORTEUR') {
      setLoading(false);
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      const response = await transporterAPI.getStatistics();
      setStats(response.data);
      setShouldRefresh(false);
    } catch (err) {
      // Ne pas logger les erreurs 403 car c'est normal si l'utilisateur n'est pas transporteur
      if (err.response?.status !== 403) {
        console.error('Erreur lors du chargement des statistiques transporteur:', err);
      }
      setError(err.response?.data?.detail || 'Erreur lors du chargement des statistiques');
    } finally {
      setLoading(false);
    }
  }, [shouldRefresh, user]);

  const refreshStats = useCallback(() => {
    setShouldRefresh(true);
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return {
    stats,
    loading,
    error,
    fetchStats,
    refreshStats,
    shouldRefresh,
  };
};